import type { FC, ReactNode } from 'react'
import React from 'react'
import type { Theme } from '@material-ui/core/styles'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      transition: 'opacity .3s ease-in-out',
    },
    isLoading: {
      opacity: 0.5,
      transition: 'opacity .3s ease-in-out',
      pointerEvents: 'none',
    },
    listWrapper: {
      display: 'flex',
      alignItems: 'center',
      // flexWrap: 'wrap',
      marginBottom: theme.spacing(1.875 / 2),
      marginTop: theme.spacing(1.5 / 2),
    },
  }),
)

interface IProps {
  children?: ReactNode
  isLoading?: boolean
  innerClassName?: string
}

const Filters: FC<IProps> = ({ children, isLoading, innerClassName }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, isLoading && classes.isLoading)}>
      <div className={clsx(classes.listWrapper, innerClassName)}>
        {children}
      </div>
    </div>
  )
}

export default Filters
